<template>
  <div class="point-details-page">
    <el-tooltip effect="dark" content="关闭" placement="top-start">
      <i @click="handleCancel" class="el-icon-close"></i>
    </el-tooltip>
    <div style="width: 400px; margin: auto; padding: 12px 0">
      <div>
        <div style="display: flex; justify-content: space-between">
          巡更点名 ： {{ options.pointName }}
          <span style="color: #407aee">【 {{ options.location }}】</span>
        </div>
      </div>
      <div style="margin: 16px 0">
        <div>打卡方式 ： {{ options.punchType == 0 ? "GPS" : "二维码" }}</div>
      </div>
      <div
        id="print"
        style="background: #fff; padding: 16px 24px; border-radius: 5px; color: black"
      >
        <!--        <div-->
        <!--          style="-->
        <!--            display: flex;-->
        <!--            align-items: center;-->
        <!--            justify-content: space-between;-->
        <!--          "-->
        <!--        >-->
        <!--          <img-->
        <!--            style="height: 70px; width: 120px"-->
        <!--            src="../../../common/assets/images/popperLogo.png"-->
        <!--            alt=""-->
        <!--          />-->
        <!--          <span style="font-size: 22px !important; margin-left: 15px"-->
        <!--            >鲁南制药集团有限公司</span-->
        <!--          >-->
        <!--        </div>-->
        <div style="display: flex; align-items: center; justify-content: space-between">
          <div>
            <div style="margin: 20px 0">巡更点编号：{{ options.pointCode }}</div>
            <div style="margin: 20px 0">巡更点名称：{{ options.pointName }}</div>
          </div>
          <span v-show="options.punchType != 0 && options.pointCode">
            <vueQr
              :text="pointCode"
              :logoSrc="downloadData.icon"
              :size="100"
              :margin="5"
            ></vueQr>
          </span>
        </div>
      </div>
    </div>

    <div class="footer">
      <!-- <el-button type="info" @click="handelDel">删除</el-button> -->
      <div>
        <!-- <el-button @click="handleUpdate" type="info">修改</el-button> -->
        <!-- <el-button
          type="info"
          @click="handlePrint"
          v-if="options.punchType != 0 && options.pointCode"
          >打印</el-button
        > -->
      </div>
    </div>
    <el-dialog
      title="修改巡更点"
      :visible.sync="pointDialog"
      width="400px"
      :append-to-body="true"
      :before-close="handleCloseDialog"
    >
      <el-form
        :model="pointForm"
        :rules="pointRules"
        label-width="100px"
        ref="refPointForm"
      >
        <el-form-item prop="name" label="巡更点名称">
          <el-input v-model="pointForm.name"></el-input>
        </el-form-item>
        <el-form-item label="打卡方式" prop="type">
          <el-radio-group v-model="pointForm.type">
            <el-radio label="0" v-if="pointForm.type == 0">GPS [ 不可更改 ]</el-radio>
            <el-radio label="1" v-if="pointForm.type == 1">二维码 [ 不可更改 ]</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="handleSaveDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import vueQr from "vue-qr";
import utils from "@src/common/utils";
export default {
  components: {
    vueQr,
  },
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pointCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // pointCode: "",
      downloadData: {
        // url: "http://10.40.146.150:8081/#/pages/workorder/handle-add?templateCode=20210617000495"//需要转化成二维码的网址
        url: "", //需要转化成二维码的网址
        icon: require("../../../../src/common/assets/images/wx.png"), //二维码中间的图片,可以不设置
      },
      pointDialog: false,
      pointForm: {
        name: "",
        type: "",
      },
      pointRules: {
        name: [{ required: true, message: "请输入巡更点名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择方式", trigger: "blur" }],
      },
      // options: {},
    };
  },
  mounted() {},
  methods: {
    handleCloseDialog() {
      this.pointDialog = false;
      this.$refs.refPointForm.resetFields();
    },
    handleSaveDialog() {
      if (!this.options.pointCode) {
        // 本地修改
        this.$emit("updateCallBack", this.pointForm.name);
        return;
      }
      this.$fetch(api.patrolplan.updatePoint, {
        pointCode: this.options.pointCode,
        pointName: this.pointForm.name,
      }).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.$emit("handleDel", this.pointForm.name);
        } else {
          this.$message({
            type: "error",
            message: res.msgContent,
          });
        }
      });
    },

    handleUpdate() {
      this.pointForm = {
        name: this.options.pointName,
        type: this.options.punchType,
      };
      this.pointDialog = true;
    },
    handleCancel() {
      this.$emit("closeTip");
    },
    handelDel() {
      this.$confirm("此操作将删除该点位, 是否继续?", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (!this.options.pointCode) {
          // 未保存的数据可以本地删除
          this.$emit("handleDel");
          return;
        }
        this.$fetch(api.patrolplan.deletePoint, {
          pointCode: this.options.pointCode,
        }).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.$emit("handleDel");
          } else {
            this.$message({
              type: "error",
              message: res.msgContent,
            });
          }
        });
      });
    },
    handlePrint() {
      let newWin = window.open("");
      const docStr = document.getElementById("print").outerHTML; //要打印的div的内容
      newWin.document.write(docStr);
      setTimeout(() => {
        newWin.print(); //打印
        newWin.close(); //关闭窗口
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
$bgcolor: rgba(30, 40, 64, 1);
// .point-details-page::before {
//   content: "";
//   position: absolute;
//   top: -20px;
//   left: calc(50% - 10px);
//   border-width: 10px;
//   border-style: solid;
//   @include set_theme_color(border-bottom-color, top-menu-bg-color);
//   border-color: transparent transparent transparent;
// }
.point-details-page {
  width: 462px;
  // height: 380px;
  padding: 20px 30px;
  border-radius: 5px;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.65);
  backdrop-filter: blur(2px);
  i {
    cursor: pointer;
    font-size: 18px;
    // color: #fff;
    position: absolute;
    top: 7px;
    right: 7px;
    padding: 2px;
    &:hover {
      color: #fff;
      background: red;
      border-radius: 50%;
      -webkit-animation: rotation 5s linear infinite;
      animation: rotation 5s linear infinite;
    }
  }
  .margin24 {
    margin: 20px 0;
  }

  .point-title {
    display: flex;
    justify-content: space-between;
  }
  .point-content {
    background: #fff;
    padding: 16px 24px;
    border-radius: 5px;
    color: black;
  }
  .point-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
}
@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
